import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

const AppPaymentVerify = () => {
  const { reference } = useParams();
  const [isFunctionCall, setIsFunctionCall] = useState(false);
  // useEffect(()=>{
  //     async function verifyHandler(){
  //          let verifyResponse= await axios.get(`https://api.lenco.co/access/v2/collections/status/${reference}`,        {
  //              headers: {
  //                'Authorization': `Bearer ${process.env.REACT_APP_LENCO_SECRET_KEY}`, // Authorization header
  //              },
  //            })
  //            console.log(verifyResponse,"verifyResponse ")
  //            if(verifyResponse?.data?.status && verifyResponse?.data.data.status==="successful")
  //            {
  //             //  carBookingHandler();
  //            }
  //      }
  //      verifyHandler();
  //    },[reference])
  const navigate = useNavigate();
  useEffect(() => {
    async function verifyHandler() {
      const interval = setInterval(async () => {
        try {
          const verifyResponse = await axios.get(
            `https://api.lenco.co/access/v2/collections/status/${reference}`,
            {
              headers: {
                Authorization: `Bearer ${process.env.REACT_APP_LENCO_SECRET_KEY}`, // Authorization header
              },
            }
          );
          console.log(verifyResponse, "verifyResponse");

          if (
            verifyResponse?.data?.status &&
            verifyResponse?.data.data.status !== "pending"
          ) {
            clearInterval(interval); // Stop the interval if status is not "pending"
            if (verifyResponse?.data.data.status === "successful") {
              // carBookingHandler(); // Call your function if the status is "successful"
              navigate(`/app-payment/success`);
            } else {
              // Handle other statuses (if needed)
              console.log(
                "Payment not successful, status:",
                verifyResponse?.data.data.status
              );
            }
          }
        } catch (error) {
          console.error("Error verifying status:", error);
          clearInterval(interval); // Stop the interval on error
        }
      }, 3000); // 3 seconds interval

      // Cleanup the interval if the component unmounts or reference changes
      return () => clearInterval(interval);
    }

    verifyHandler();
  }, [reference]);

  return (
    <>
      {!isFunctionCall && (
        //  <div className="loader-overlay">
        //  <div className="loader-container">
        //    <p>Please wait...</p>
        //    <div className="loader-dots-circle">
        //      <span></span>
        //      <span></span>
        //      <span></span>
        //      <span></span>
        //      <span></span>
        //    </div>
        //  </div>
        // </div>
        <div className="loader-overlay">
          <div className="loader-container ms-3">
            <div className="ml-loader">
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
            </div>
            <p>Please wait...</p>
          </div>
        </div>
      )}
    </>
  );
};

export default AppPaymentVerify;
